export { default } from './ActivityFilterBottom'
